import Splide from '@splidejs/splide'; //? https://splidejs.com/

document.addEventListener( 'DOMContentLoaded', function () {
	
    var homeCarousel = document.querySelector(".home-hero-slider");
	
    if(homeCarousel){

        var homeHeroCarousel = new Splide( '.home-hero-slider', {
            type: 'fade',
            autoplay: true,
            //gap: 0,
            //perPage: 1,
            //perMove: 1,
            //interval: 4000,
            //speed: 200,
            //lazyLoad: 'nearby',
            //isNavigation: false,
            rewind: true,
            arrows: false,
            pagination: false,
            pauseOnHover: false	
        }).mount();

    }

});